import { toast } from 'react-toastify';

const fallbackName = (base, format) => `${base}.${format === 'xls' ? 'xls' : 'xlsx'}`;

const parseFilename = (headerValue, fallback) => {
  if (!headerValue) return fallback;
  const utf8Match = headerValue.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match) return decodeURIComponent(utf8Match[1]);
  const asciiMatch = headerValue.match(/filename="?([^";]+)"?/i);
  return asciiMatch ? asciiMatch[1] : fallback;
};

export const downloadReport = async ({ api, endpoint, params, format = 'xlsx', baseName = 'reporte' }) => {
  try {
    const response = await api.get(endpoint, {
      params: { ...params, file_format: format },
      responseType: 'blob',
    });
    const blob = new Blob([response.data], {
      type:
        format === 'xls'
          ? 'application/vnd.ms-excel'
          : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const filename = parseFilename(
      response.headers?.['content-disposition'],
      fallbackName(baseName, format)
    );
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    toast.success(`Reporte ${format.toUpperCase()} generado.`);
  } catch (error) {
    toast.error(error?.response?.data?.error || 'No se pudo generar el reporte.');
  }
};
